"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var useCatalogPreferences_1 = require("stremio/common/useCatalogPreferences");
var applyCatalogPreferences = function (catalogs, preferences) {
    var _a, _b;
    if (!catalogs || catalogs.length === 0) {
        return {
            filteredCatalogs: [],
            heroItems: [],
            heroSectionEnabled: (_a = preferences.heroSectionEnabled) !== null && _a !== void 0 ? _a : true,
        };
    }
    // Get catalog IDs and their preferences
    var catalogMap = new Map();
    catalogs.forEach(function (catalog, index) {
        var id = (0, useCatalogPreferences_1.getCatalogId)(catalog);
        if (id) {
            catalogMap.set(id, { catalog: catalog, index: index });
        }
    });
    // Apply preferences: filter enabled, apply order
    var enabledCatalogs = [];
    var catalogOrder = preferences.catalogOrder || [];
    var catalogPreferences = preferences.catalogPreferences || {};
    catalogMap.forEach(function (_a, id) {
        var catalog = _a.catalog, index = _a.index;
        var pref = catalogPreferences[id] || { enabled: true, order: -1, showInHero: true };
        if (pref.enabled !== false) {
            // Use explicit order from catalogOrder array if present, otherwise use original index
            var order = catalogOrder.indexOf(id) >= 0 ? catalogOrder.indexOf(id) : index;
            enabledCatalogs.push({ catalog: catalog, order: order, id: id });
        }
    });
    // Sort by order
    enabledCatalogs.sort(function (a, b) {
        return a.order - b.order;
    });
    var filteredCatalogs = enabledCatalogs.map(function (_a) {
        var catalog = _a.catalog;
        return catalog;
    });
    // Collect hero items from catalogs with showInHero enabled
    // Limit to first 20 items to avoid performance issues
    var heroItems = [];
    var MAX_HERO_ITEMS = 20;
    if (preferences.heroSectionEnabled !== false) {
        filteredCatalogs.forEach(function (catalog) {
            var _a, _b, _c, _d;
            if (heroItems.length >= MAX_HERO_ITEMS)
                return;
            var id = (0, useCatalogPreferences_1.getCatalogId)(catalog);
            if (id) {
                var originalIndex = (_b = (_a = catalogMap.get(id)) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : -1;
                var pref = catalogPreferences[id];
                var showInHero = (_c = pref === null || pref === void 0 ? void 0 : pref.showInHero) !== null && _c !== void 0 ? _c : (originalIndex === 0);
                if (showInHero !== false) {
                    if (((_d = catalog.content) === null || _d === void 0 ? void 0 : _d.type) === 'Ready' && Array.isArray(catalog.content.content)) {
                        catalog.content.content.forEach(function (item) {
                            // Include all items from hero-enabled catalogs
                            // Missing background/logo will be fetched by Board component
                            if (item && heroItems.length < MAX_HERO_ITEMS) {
                                heroItems.push(item);
                            }
                        });
                    }
                }
            }
        });
    }
    return {
        filteredCatalogs: filteredCatalogs,
        heroItems: heroItems,
        heroSectionEnabled: (_b = preferences.heroSectionEnabled) !== null && _b !== void 0 ? _b : true,
    };
};
exports.default = applyCatalogPreferences;
